const activityObject = {
    id: "",
    name: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    log_type_id: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    note: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    activitable_id: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    activitable_type: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    created_by_id: {
        value: "",
        error: false,
        message: "",
        required: false
    },
    created_at: {
        value: "",
        error: false,
        message: "",
        required: false
    },
}
export const resetErrors = (currentObject) => {
    var objectKeys = Object.keys(currentObject);

    var updatedObject = {
        ...currentObject
    }
    try {
        objectKeys.filter(key => key !== "id").map((key) => {

            updatedObject[key]["error"] = false
            updatedObject[key]["message"] = ""
        })
    } catch (error) {

    }

    return updatedObject

}
export const checkErrors = (errorMessages, currentObject) => {

    const errorMessagesKeys = Object.keys(errorMessages);
    errorMessagesKeys.map((key) => {
        if (!key?.includes('contacts')) {
            let messages = []
            errorMessages[key].map((message) => {
                messages.push(message)
            })

            currentObject[key]["error"] = true
            currentObject[key]["message"] = messages
        }
    })

    return currentObject
}
export const objectMerge = (updatedObject) => {
    const mergedObject = {
        ...updatedObject,
        id: updatedObject?.id,
        name: {
            value: updatedObject?.name,
            error: false,
            message: "",
            required: false
        },
        log_type_id: {
            value: updatedObject?.log_type_id,
            error: false,
            message: "",
            required: false
        },
        note: {
            value: updatedObject?.note,
            error: false,
            message: "",
            required: false
        },
        activitable_id: {
            value: updatedObject?.activitable_id,
            error: false,
            message: "",
            required: false
        },
        activitable_type: {
            value: updatedObject?.activitable_type,
            error: false,
            message: "",
            required: false
        },
        created_by_id: {
            value: updatedObject?.created_by_id,
            error: false,
            message: "",
            required: false
        },
        created_at: {
            value: updatedObject?.created_at,
            error: false,
            message: "",
            required: false
        },
    }

    return mergedObject;
}
export const resetObject = (currentObject, obj) => {
    // var objectKeys = Object.keys(currentObject);

    try {

        currentObject[obj]["error"] = false
        currentObject[obj]["message"] = ""
    } catch (error) {

    }

    return currentObject
}
export default activityObject;